GET_PM_SECTION_ERROR_CACHE_TIME